import { Avatar, Box, Button, Link, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { MESSAGE_TYPES } from "../../shared/constants/constants";
import { Close, Done, PriorityHigh } from "@mui/icons-material";
import { useNavigate } from "react-router";

type PageMessageProps = {
  heading?: string;
  content?: string;
  link?: string;
  linkContent?: string;
  type: string;
  customElement?: any;
  state?: any;
};

const PageMessage = ({
  heading,
  content,
  link,
  linkContent,
  type,
  customElement,
  state = {},
}: PageMessageProps) => {
  const [typeStyle, setTypeStyle] = useState({
    bgColor: "",
    border: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (type === MESSAGE_TYPES.ERROR) {
      setTypeStyle({
        bgColor: "rgba(255, 175, 179, 0.2)",
        border: "#ED1B24",
      });
    } else if (type === MESSAGE_TYPES.SUCCESS) {
      setTypeStyle({
        bgColor: "rgba(188, 252, 161, 0.2)",
        border: "#389E0F",
      });
    } else if (type === MESSAGE_TYPES.WARNING) {
      setTypeStyle({
        bgColor: "rgba(249, 231, 137, 0.2)",
        border: "#EFA108",
      });
    } else if (type === MESSAGE_TYPES.INFO) {
      setTypeStyle({
        bgColor: "rgba(161, 203, 252, 0.2)",
        border: "#22438C",
      });
    }
  }, [type]);

  const IconType = () => {
    if (type === MESSAGE_TYPES.ERROR) {
      return <Close />;
    } else if (type === MESSAGE_TYPES.SUCCESS) {
      return <Done />;
    } else if (type === MESSAGE_TYPES.WARNING) {
      return <PriorityHigh />;
    } else if (type === MESSAGE_TYPES.INFO) {
      return <PriorityHigh />;
    } else {
      return <></>;
    }
  };

  return (
    <>
      <Stack
        direction={"row"}
        sx={{
          backgroundColor: typeStyle?.bgColor,
          borderLeft: 3,
          borderColor: typeStyle?.border,
        }}
        display={"flex"}
        justifyContent={"flex-start"}
        alignItems={"flex-start"}
        p={1}
      >
        <Box py={2}>
          <Avatar sx={{ bgcolor: typeStyle?.border }}>
            <IconType />
          </Avatar>
        </Box>
        <Stack
          width={"80%"}
          p={2}
          spacing={1}
          display={"flex"}
          justifyContent={"center"}
        >
          {heading && (
            <Typography fontWeight={500} fontSize={"18px"}>
              {heading}
            </Typography>
          )}
          {content && (
            <Typography fontWeight={300} fontSize={"14px"}>
              {content}
            </Typography>
          )}
          {
            customElement ?? <></>
          }
          {link && linkContent && (
            // <Link
            //   sx={{
            //     fontSize: "14px",
            //     fontWeight: "300",
            //     color: "#22438C",
            //   }}
            //   fontWeight={400}
            //   fontSize={18}
            //   href={link}
            // >
            //   {linkContent}
            // </Link>
            <Button
              sx={{
                p: 0,
                diisplay: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                width: "max-content",
              }}
              variant="text"
              onClick={() =>
                navigate(`${link}`, {
                  state: { ...state },
                })
              }
            >
              <Typography
                fontWeight={300}
                fontSize={"14px"}
                textTransform={"none"}
                color={"#22438C"}
              >
                {linkContent}
              </Typography>
            </Button>
          )}
        </Stack>
      </Stack>
    </>
  );
};

export default PageMessage;
